export const TENANT_SWITCHER_FEATURE_FLAG = "synergists.show-tenant-switcher";
export const STOREFRONT_SWITCHER_FEATURE_FLAG = "nomads.storefront-switcher";
